import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { DrawerRef, DRAWER_DATA_VAR } from 'mis-crystal-design-system/drawer';
import { PaymentService } from 'src/app/shared/services/paymentService.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { MyBookingsService } from '../my-bookings.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { environment } from 'src/environments/environment';


declare var Razorpay: any;
@Component({
  selector: 'app-payment-cart',
  templateUrl: './payment-cart.component.html',
  styleUrls: ['./payment-cart.component.scss']
})
export class PaymentCartComponent implements OnInit {
  payments: any;
  currentPage = 1;
  pageSize = 20;
  public startDate: any;
  public endDate: any;
  public config: any;
  showToast = false;
  toastMessage = '';
  destroy$ = new Subject();
  public options;
  public rzp1: any;
  requestObj: any;
  isLoading = false;
  noCardDetails = true;
  carDetails;
  selectedValue;
  request;
  dates: any;
  totalAmt = 0;
  successPopup = false;


  constructor(private drawerRef: DrawerRef,
              @Inject(DRAWER_DATA_VAR) private data: any,
              private myBookingService: MyBookingsService,

              private paymentService: PaymentService,
              private authService: AuthService,
              private cdr: ChangeDetectorRef) {
    this.options = {
      key: environment.razorPayApiKey,
      amount: 100,
      image: 'assets/MoveinSync-Rentlz.png',
      prefill: {
        contact: null,
        email: null
      },
      theme: {
        color: 'rgb(19, 54, 130)'
      },
      handler: this.handleRazorPayPayment.bind(this),
      save: 1
    };
    this.requestObj = {
      amount: 100,
      appName: "SPOT",
      details: {},
      paymentType: "razorpay",
      buid: this.authService.user.buId,
      userEmail: this.authService.user.info.employee.emailId,
      userName: this.authService.user.info.employee.employeeName
    };
  }



  ngOnInit(): void {
    this.request = {
      userEmail: this.authService.user.info.employee.emailId,
      buid: this.authService.user.buId,
    };
    this.options['name'] = 'Trip Amount';
    this.options.prefill.contact = this.authService.user.info ? this.authService.user.info?.employee.phone : '';
    this.options.prefill.email = this.authService.user.info ? this.authService.user.info?.employee.emailId : '';

    this.myBookingService.pastStartDate.subscribe(res => this.startDate = res);
    this.myBookingService.pastEndDate.subscribe(res => this.endDate = res);
    this.getPaymentDetails();
  }

  getPaymentDetails() {
    const paymentbody = {
      employeeGuid: this.authService.user.employeeGuid,
      startDate: this.startDate,
      endDate: this.endDate,
      buid: this.authService.user.buId,
      myBookings: true,
      pageNum: this.currentPage,
      pageSize: this.pageSize,

    };
    const paymentqueryString = {
      loginBuid: this.authService.user.buId,
      loginClient: this.authService.client.client,
      loginEmpGuid: this.authService.user.employeeGuid
    };
    this.myBookingService.fetchPaymentCart(paymentqueryString, paymentbody).subscribe((res) => {
      this.payments = res;
      this.payments.forEach((item) => {
        this.totalAmt = this.totalAmt + item.amount;
      });
    });
  }

  handlePayment() {
    this.paymentService.openRazorPayForAddingCard(this.requestObj).
      pipe(takeUntil(this.destroy$)).
      subscribe((res) => {
        if (res && res["id"]) {
          this.options["order_id"] = res["id"];
          this.options["customer_id"] = res["customerId"];
          this.options["recurring"] = '1';
          this.rzp1 = new Razorpay(this.options);
          this.rzp1.open();
        }
      },
        () => {
          this.showToast = true;
          this.toastMessage = "Something went wrong. Please try again later";
        });
  }

  handleRazorPayPayment(response) {

    this.myBookingService.verifyPayment(response).subscribe((res) => {
      if (res) {
        this.myBookingService.bulkPaymentPopup.next(true);
        this.myBookingService.paymentStatus.next(res);
        this.myBookingService.totalAmount.next(this.totalAmt);

        this.drawerRef.close();
      }
    });

    this.fetchCardDetails();
  }

  fetchCardDetails() {
    this.isLoading = true;
    this.paymentService.fetchCardDetails(this.request).
      pipe(takeUntil(this.destroy$)).
      subscribe((data) => {
        this.isLoading = false;

        if (data.status === 204) {
          this.noCardDetails = true;
        }


        if (data.status == 200) {
          this.noCardDetails = false;
          this.carDetails = data['body'];
          this.selectedValue = this.carDetails[0]['defaultCard'];
          this.cdr.detectChanges();
        }
      }, (error) => {
        this.showToast = true;
        this.toastMessage = "Something went wrong. Please try again later";

      }

      );
  }


  close() {
    this.drawerRef.close();
  }

  ngOnDestroy(): void {
    if (this.drawerRef) {
      this.drawerRef.close();
    }
  }
}
